<template lang="html">
  <div class="email-form">
    <label>Seleccioná el método para reiniciar tu contraseña:</label>
    <div class="mt-3">

      <!-- Radio buttons -->
      <div class="my-3">
        <div class="w-100 d-flex align-items-baseline recovery-method ">
          <input id="email" type="radio" name="recoveryMethod" value="email" v-model="method">
          <label for="email">Email con enlace de recuperación</label>
        </div>
        <div class="w-100 d-flex align-items-baseline recovery-method mt-3">
          <input id="message" type="radio" name="recoveryMethod" value="code" v-model="method">
          <label for="message">Código de verificación por SMS o llamada</label>
        </div>
      </div>

      <!-- Continue/Cancel buttons -->
      <div class="d-flex justify-content-center">
        <button @click="$emit('close')" class="btn btn-default mt-3">
          Cancelar
        </button>
        <button @click="continueProcess" class="btn btn-primary mt-3">
          Continuar
        </button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    then: Function,
    props: Object
  },
  data: () => ({
    method: 'email'
  }),
  methods: {
    continueProcess () {
      this.$emit('close');
      this.then(this.method);
    }
  }
}
</script>

<style lang="scss" scoped>
.recovery-method {
  input {
    transform: scale(1.5);
  }
  label {
    margin-left: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/SelectRecoveryMethodForm.vue